import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import { faTrashCan, faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import {
    faEllipsis,
    faUserSecret,
    faKey,
    faWallet,
    faSliders,
    faGift,
    faGear,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DropDownButtons = (props) => {
    return (
        <DropdownButton
            id="dropdown-basic-button"
            title={<FontAwesomeIcon icon={faEllipsis} />}
            variant="none"
        >
            {props.edit ? (
                <Dropdown.Item
                    onClick={() => {
                        props.edit();
                    }}
                >
                    <FontAwesomeIcon icon={faPenToSquare} size="sm" />
                    تعديل
                </Dropdown.Item>
            ) : null}
            {props.delete ? (
                <Dropdown.Item
                    onClick={() => {
                        props.delete();
                    }}
                >
                    <FontAwesomeIcon icon={faTrashCan} size="sm" />
                    حذف
                </Dropdown.Item>
            ) : null}
            {props.deleteForVendor ? (
                <Dropdown.Item
                    disabled={props.deleteForVendorDisabled}
                    onClick={() => {
                        if (!props.deleteForVendorDisabled) {
                            props.deleteForVendor();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faTrashCan} size="sm" />
                    حذف للمطعم فقط
                </Dropdown.Item>
            ) : null}
            {props.deleteForDelivery ? (
                <Dropdown.Item
                    disabled={props.deleteForDeliveryDisabled}
                    onClick={() => {
                        if (!props.deleteForDeliveryDisabled) {
                            props.deleteForDelivery();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faTrashCan} size="sm" />
                    حذف للسائق فقط
                </Dropdown.Item>
            ) : null}
            {props.changePassword ? (
                <Dropdown.Item
                    onClick={() => {
                        props.changePassword();
                    }}
                >
                    <FontAwesomeIcon icon={faKey} size="sm" /> تغيير كلمة المرور
                </Dropdown.Item>
            ) : null}
            {props.wallet ? (
                <Dropdown.Item
                    onClick={() => {
                        props.wallet();
                    }}
                >
                    <FontAwesomeIcon icon={faWallet} size="sm" /> المحفظة
                </Dropdown.Item>
            ) : null}
            {props.walletSettings ? (
                <Dropdown.Item
                    onClick={() => {
                        props.walletSettings();
                    }}
                >
                    {/* "السائقين" since the restaurant wallet has its own item
                        below — two items both called «إعدادات المحفظة» would
                        not say which is which. */}
                    <FontAwesomeIcon icon={faSliders} size="sm" /> محفظة السائقين
                </Dropdown.Item>
            ) : null}
            {props.vendorWalletSettings ? (
                <Dropdown.Item
                    onClick={() => {
                        props.vendorWalletSettings();
                    }}
                >
                    <FontAwesomeIcon icon={faWallet} size="sm" /> محفظة المطاعم
                </Dropdown.Item>
            ) : null}
            {props.freeDeliverySettings ? (
                <Dropdown.Item
                    onClick={() => {
                        props.freeDeliverySettings();
                    }}
                >
                    <FontAwesomeIcon icon={faGift} size="sm" /> عروض التوصيل المجاني
                </Dropdown.Item>
            ) : null}
            {props.operationalSettings ? (
                <Dropdown.Item
                    onClick={() => {
                        props.operationalSettings();
                    }}
                >
                    <FontAwesomeIcon icon={faGear} size="sm" /> الإعدادات التشغيلية
                </Dropdown.Item>
            ) : null}
            {props.impersonate ? (
                <Dropdown.Item
                    onClick={() => {
                        props.impersonate();
                    }}
                >
                    <FontAwesomeIcon icon={faUserSecret} size="sm" /> انتحال هوية
                </Dropdown.Item>
            ) : null}
        </DropdownButton>
    );
};
export default DropDownButtons;
